// client/src/bids/index.ts
import { BidList } from './BidList';
import { BidEdit } from './BidEdit';
import { BidCreate } from './BidCreate';
import BidIcon from '@mui/icons-material/ListAlt';

export default {
    list: BidList,
    edit: BidEdit,
    icon: BidIcon,
};
